import { render, staticRenderFns } from "./shadow.vue?vue&type=template&id=9fc7f58a&scoped=true"
import script from "./shadow.vue?vue&type=script&lang=js"
export * from "./shadow.vue?vue&type=script&lang=js"
import style0 from "./shadow.vue?vue&type=style&index=0&id=9fc7f58a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc7f58a",
  null
  
)

export default component.exports